import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Compass } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      sessionStorage.setItem("ft_admin_token", data.access_token);
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 relative z-10 p-6">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        onSubmit={submit}
        className="w-full max-w-sm bg-slate-800 border border-slate-700 rounded-2xl p-8"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 text-white mb-1">
          <Compass className="text-coastal-accent" size={22} />
          <span className="font-heading text-xl">Free Tour Torrevieja</span>
        </div>
        <p className="text-slate-400 text-sm mb-8 flex items-center gap-1.5">
          <Lock size={13} /> Panel de administración
        </p>

        <Label className="text-slate-300">Email</Label>
        <Input
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1.5 mb-4 bg-slate-900 border-slate-700 text-white"
          required
        />
        <Label className="text-slate-300">Contraseña</Label>
        <Input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1.5 mb-2 bg-slate-900 border-slate-700 text-white"
          required
        />
        {error && <p className="text-red-400 text-sm mb-2" data-testid="admin-login-error">{error}</p>}

        <Button
          type="submit"
          data-testid="admin-login-btn"
          disabled={loading}
          className="w-full mt-4 rounded-full bg-coastal-accent hover:bg-coastal-accent/90 text-white"
        >
          {loading ? "..." : "Entrar"}
        </Button>
      </motion.form>
    </div>
  );
};

export default AdminLogin;
